import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[9998] transition-all duration-400 ease-out`}
      style={{
        background: scrolled
          ? 'rgba(8,8,8,0.92)'
          : 'transparent',
        backdropFilter: scrolled ? 'blur(20px)' : 'none',
        WebkitBackdropFilter: scrolled ? 'blur(20px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(255,255,255,0.07)' : 'none',
        boxShadow: scrolled ? '0 2px 24px rgba(0,0,0,0.3)' : 'none',
      }}
    >
      <div className="flex items-center justify-between px-5 md:px-10 py-3 md:py-4">
        {/* ロゴ */}
        <a
          href="https://mever.design"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/a6432ee4b37c265c1d5171353c491488.png"
            alt="MeVER Logo"
            className="h-5 md:h-6 w-auto object-contain brightness-0 invert opacity-90"
          />
        </a>

        {/* 右側：CTAボタン */}
        <a
          href="https://mever.design/products/mever-chair-pro-ver2"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full font-bold text-[11px] md:text-xs tracking-wide whitespace-nowrap cursor-pointer transition-all duration-300 hover:scale-[1.04]"
          style={{
            background: 'rgba(168,85,247,0.15)',
            border: '1px solid rgba(168,85,247,0.35)',
            color: '#c084fc',
          }}
        >
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-shopping-bag-3-line text-xs"></i>
          </span>
          今すぐ予約
        </a>
      </div>
    </header>
  );
}
